export function addToLocalStorage(key: string, item: any) {
    if (localStorage && typeof item !== "undefined") {
        localStorage.setItem(key, JSON.stringify(item));
    }
}
